export const setChannelRegistrationFormIsOpen = (state, action) => {
  state.channelRegisterationFormIsOpen = action.payload
}
